import { CIMSModal } from 'components/CIMSModal'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSTextArea from 'components/CIMSTextArea'
import { CIMSModalWrapperProps } from 'components/CIMSModal/types'
import { useRFITrackerContext } from '../../../../../RFITrackerContext'
import { Response } from '../../../../../RFITrackerContext/types'
import { useEditRfiResponseMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { errorHandler } from 'hooks/errorHandler'
import { useState } from 'react'
import { HelpMessage } from 'utils/constants'

export type EditRFIResponseModalData = Pick<Response, 'id' | 'text'>

const EditResponseModal: React.FC<
  CIMSModalWrapperProps<EditRFIResponseModalData>
> = ({ visible, onClose, state }) => {
  const { refetch } = useRFITrackerContext()
  const [edit] = useEditRfiResponseMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editRFIResponse: {
        response: {
          user: { mail, displayName },
        },
      },
    }) => simpleEditNotification(`Response by ${displayName ?? mail}`),
  })
  const [loading, setLoading] = useState(false)

  return (
    <CIMSModal
      title="Edit RFI Response"
      visible={visible}
      loading={loading}
      initialFormValues={{ text: state?.text ?? '' }}
      onCancel={onClose}
      onOk={async ({ text }: { text: string }) => {
        if (!state?.id) return errorHandler('Response id must be defined')
        setLoading(true)
        await edit({
          variables: {
            input: {
              id: state.id,
              text,
            },
          },
        })
        setLoading(false)
        refetch()
        onClose()
      }}
    >
      <CIMSFormItem
        name="text"
        label="Response"
        requiredMessage
        help={HelpMessage.RequestsForInformation.RFITracker.Response}
      >
        <CIMSTextArea />
      </CIMSFormItem>
    </CIMSModal>
  )
}

export default EditResponseModal
